module.exports = __webpack_public_path__ + "static/media/Unofficial_JavaScript_logo_2.dd60b11e.svg";